
import { industrialApeActivity, industrialApeExec, industrialApeList,industrialApeSeriesCount } from "@/api/projectManager_self";

class Service {
    static activityCode = 'industrial';
    static collectionId = 209;

    /**
     * @description 获取活动数据
    */
    static getActivityData = async () => {
        const res = await industrialApeActivity({activityCode: Service.activityCode})
        if (res.code !== '000000') throw res.msg;
        return res.data;
    }
     
    
    /**
     * @description 获取活动配置
    */
    static getActivityConfig = async () => {
        const res = await industrialApeActivity({activityCode: Service.activityCode})
        if (res.code !== '000000') throw res.msg;
        return res.data;
    }

    /**
     * @description 获取用户信息
    */
    static getUserCertificateStatus = async () => {
        if (window.JsBridge.hasWebViewBridge()) {
          const res = await window.JsBridge.getDetailCurrentUserInfo()
          return res;
        } else {
          return {};
        }
    }

}

export default Service;